"use client";

import styles from "./LoginSubmitButton.module.scss";

import { useLoginForm } from "../../_hooks";
import { useTranslations } from "@/i18n";
import { Button } from "@vetty/ui";

/**
 * LoginSubmitButton Component
 *
 * Submit button for login form using custom hook for logic.
 * Simplified component that delegates all logic to useLoginForm hook.
 */
export const LoginSubmitButton = () => {
  const t = useTranslations("login.form");

  // Get login functionality from custom hook
  const { submitLogin, loading } = useLoginForm();

  return (
    <Button
      disabled={loading}
      loading={loading}
      onClick={submitLogin}
      className={styles["comp"]}
    >
      {t("submit")}
    </Button>
  );
};
